import { Event } from "event-system";
import { CancellationToken } from "./CancellationToken";

export class CancellationTokenSource {
    public readonly token: CancellationToken;
    private readonly initialToken: CancellationToken;

    public get onCanceled(): Event<void> {
        return this.initialToken == null ? this.token.onCanceled : this.initialToken.onCanceled;
    }
    
    public constructor(token?: CancellationToken) {
        this.token = new CancellationToken();
        this.initialToken = token;
        this.initialToken?.onCanceled.add(this.onTokenCancelled, this);
    }

    public cancel(): void {
        this.token.cancel();
    }

    public dispose(): void {
        this.initialToken?.onCanceled.remove(this.onTokenCancelled, this);
    }

    private onTokenCancelled(): void {
        this.token.cancel();
    }
}